// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3BAI1","paramInput":"JobSimulator_paramInput__28Cp-","input":"JobSimulator_input__12Lbf"};